import { getItem } from "./alternatePaymentMethodsStorage.js";
import { getItem as getItem$1 } from "./responseStorage.js";
const queryFnFactory = (config, keyProps) => {
  return () => {
    return new Promise((resolve) => {
      const { accountId } = keyProps;
      const paymentMethodIds = getItem(accountId) || [];
      resolve({
        paymentMethods: paymentMethodIds.map(
          (paymentMethodId) => getItem$1(paymentMethodId)
        )
      });
    });
  };
};
export {
  queryFnFactory as default
};
//# sourceMappingURL=query.js.map
